<template>
  <div class="game">
  </div>
</template>

<script>
import Character from '@/components/Character'
import Inventory from '@/components/Inventory'
import Actions from '@/components/Actions'

export default {
  name: 'Game',
  components: { Character, Inventory, Actions },
  sockets: {
    connect () {
      this.$socket.emit('login', {
        username: 'eidynn',
        password: 'eidynn'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/game.vue